import Button, { ButtonA } from "components/Elements/Button/Button";
import Image from "components/Elements/Image/Image";
import PRODUCT_LIST from "../../../../helpers/productList";
import useApp from "hooks/useApp";
import useIsIsraelUser from "../../hooks/useIsIsraelUser";
import Icon from "components/Elements/Icon/Icon";
import { LinkToNewTab } from "components/Elements/Link/Link";
import { memo } from "react";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./forBusinessesSection.module.scss";

interface ForBusinessesSectionI extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * ForBusinessesSection component represents the section of the mega menu
 */

// Export for testing purposes:
export const ForBusinessesSection = (props: ForBusinessesSectionI) => {
  const { getHtmlByKey, getTextByKey } = useContent();
  const { theme } = useApp();

  const isIsraelUser = useIsIsraelUser();

  return (
    <div className={`${styles.sectionWrapper} ${styles[theme]}`} {...props}>
      <div className={styles.sectionTitle}>
        <div className={styles.icon}>
          <Icon name="briefcase" />
        </div>
        <div className={styles.text}>
          <h3>{getTextByKey("for-businesses-title")}</h3>
          <p>{getTextByKey("for-businesses-description")}</p>
        </div>
        {/*@ts-ignore*/}
        <ButtonA page="for-businesses">{getTextByKey("learn-more")}</ButtonA>
      </div>
      <ul className={styles.productList}>
        {PRODUCT_LIST.filter((product) =>
          // Show JUMBOpay only for users from Israel
          product.name === PRODUCT_LIST[2].name ? isIsraelUser : true
        ).map((product) => (
          <li key={product.name}>
            <Image name={`features/${product.name}_logo`} />
            <h4 className={styles.title}>
              {getTextByKey(product.name + "-title")}
            </h4>
            <p className={styles.description}>
              {getHtmlByKey(product.name + "-description")}
            </p>
            {/*@ts-ignore*/}
            <LinkToNewTab
              page={`jumbo-${product.name}`}
              classes={styles.linkWrapper}
            >
              <Button className={styles.learnMoreButton}>
                {getTextByKey("learn-more")}
              </Button>
            </LinkToNewTab>
          </li>
        ))}
      </ul>
    </div>
  );
};

// Export default for use in the application:
export default memo(ForBusinessesSection);
